import { createSlice } from "@reduxjs/toolkit";
import addConsultationCharges from "@custom/rtk-apis/billing/consultation/addConsultationCharges";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const addConsultationChargesSlice = createSlice({
  name: "addConsultationChargesSlice",
  initialState,
  reducers: {
    clearAddConsultationCharges: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addConsultationCharges.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addConsultationCharges.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(addConsultationCharges.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default addConsultationChargesSlice.reducer;
export const { clearAddConsultationCharges } = addConsultationChargesSlice.actions;
